<script>
  import Modal from "../../../../../Shared/Slots/modal.svelte"
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  export let template
</script>

<Modal>
  <span slot="header">
    <div class="flex w-full items-center justify-center rounded-md bg-white p-6 text-black backdrop-blur-md dark:bg-bodyblack">
      <h1 class="text-center text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Delete File Design Template</h1>
    </div>
  </span>

  <span slot="content">
    <div class="break-words p-3 text-center text-gray-400 dark:bg-bodyblack md:p-6">
      Do you want to delete this
      <strong class="font-bold text-blue-500">{template.name}</strong>
      File Design template?
    </div>
  </span>

  <span slot="footer">
    <div class="flex flex-row items-center justify-center gap-3 rounded-md bg-white p-4 dark:bg-bodyblack dark:text-white sm:flex md:gap-0">
      <button on:click type="button" class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-blue-500 hover:text-white focus:outline-none dark:bg-lightgray dark:text-white dark:hover:bg-blue-500 sm:ml-3 sm:w-auto">
        <span>
          <i class="fa-solid fa-circle-xmark" />
        </span>
        <span class="select-none">&nbsp;No</span>
      </button>
      <button
        on:click={() => {
          dispatch("delete")
        }}
        type="button"
        class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-red-500 hover:text-white focus:outline-none dark:bg-lightgray dark:text-white dark:hover:bg-red-500 sm:ml-3 sm:w-auto"
      >
        <span>
          <i class="fa-solid fa-circle-check" />
        </span>
        <span class="select-none">&nbsp;Yes</span>
      </button>
    </div>
  </span>
</Modal>
